import { Component, OnInit } from '@angular/core';

import { ErrorStateMatcher } from '@angular/material/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { GeneralService } from '../services/general.service';
import Swal from 'sweetalert2';
import { DatePipe } from '@angular/common';
/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: 'app-actionplan',
  templateUrl: './actionplan.component.html',
  styleUrls: ['./actionplan.component.scss']
})

export class ActionPlanComponent implements OnInit {
  step = 0;
  audit: any[]=[];
  currentuser: any;
  client: any;
  clientmodule: any[]=[]  ;
  clientaudit: any[]=[];
  canview:boolean;
  Branches: any;

  modulecat: any[]=[];
  clientauditcat:  any[]=[];
  titlefileFormControl = new FormControl('', [Validators.required]);
  fileFormControl = new FormControl('', [Validators.required]);

  form = {
    startdate: '',
    enddate: '',
    moduleid:'',
    departmentid:'',
    assignerid:'',
    branchid:'',
    state:'',
  };
  matcher = new MyErrorStateMatcher();
  questions:  any[]=[];
  expiredduedate: boolean;
  allstate: any;
  allassigner: any;
  id: any;
  Departments: any;
  today:Date = new Date();
  Stats=[{
    id:1,
    name:"All",
    value:''
  },{
    id:2,
    name:"Open",
    value:"false"
  },{
    id:3,
    name:"Close",
    value:"true"
  }]
  ActionPlanData: any;
  filteredData: any;
  searchText: any;
  originaldata: any;
  auditers: any;
  createdate: string;
  constructor(public GeneralService: GeneralService,private datePipe:DatePipe
  ) {
    var clientdata = JSON.parse(localStorage.getItem('ClientData'));
this.createdate = this.datePipe.transform(clientdata.createdDate, 'yyyy-MM-dd')!;

    const user=  localStorage.getItem("userid")
    console.log(user,"ClientdashboardId");
        if(user){
          this.id=user;
          localStorage.setItem("userid",this.id);
          console.log("Come From Admin")
        }
        else {
          this.currentuser=JSON.parse(localStorage.getItem("currentuser"))
          this.id=this.currentuser.clientid
          console.log(this.currentuser)
          console.log("Come From Login")
        }
   this.getclientbyid();
  }
  getcatbymodule(moudelId){
  let modulename=  this.clientmodule.filter(res=> res.id==moudelId);
  this.modulecat = modulename[0].categories;
  console.log(this.modulecat)
  }
//   getAssingerByClientId(ClientId){
// this.GeneralService.getAssingerByClientId(ClientId).then(res=>{
//   console.log(res);
//   this.allassigner=res
// })
//   }
  getallDepartment(){
    this.GeneralService.getallDepartment().then(res=>{
      console.log(res);
      this.Departments=res
    })
  }

  getAssignerbyDepartment(DepartmentId){
    this.form.assignerid=null
this.getallAssingerByDepartmentId(this.id,DepartmentId)
  }
  getBranchByClientId(){
    this.GeneralService.getBranchByClientId(this.id).then(res=>{
      console.log(res)
      this.Branches=res;
    })
  }
  getallAssingerByDepartmentId(ClientId,DepartmentId){
    console.log(DepartmentId)
    this.GeneralService.getallAssingerByDepartmentId(ClientId,DepartmentId).then(res=>{
      console.log(res);
      this.allassigner=res
    })
      }
  getclientbyid(){
    this.GeneralService.getclientbyid(this.id).then(res=>{
      this.client=res;
      console.log(this.client)
      this.clientmodule=this.client[0].moudlerf ;
             console.log("clientmodule",this.clientmodule)
    let  auditdate=new Date(Math.max.apply(null, this.audit.map(function(e) {
      return new Date(e.StartDate);    
    })));
    });
  }
  open(img){
    console.log(img)
    Swal.fire({
      imageUrl: img,
      // imageWidth: 500,
      // imageHeight: 400,
      imageAlt: 'Custom image',
    })
  }

  setStep(index: number) {
    this.step = index;
  }

  ngOnInit() {
    this.getallDepartment();
    this.getBranchByClientId();
    this.GeneralService.getAuditerbyclientid(this.id).then(res=>{
      this.auditers = res;
    })
    // this.getAssingerByClientId(this.id);

    // this.getallAssinger();
    // this.GeneralService.getauditbyclientid(this.id).then(res=>{
    //   console.log("ALl Audit",res);
    //       })

  }

  Search(){
   if(this.form.state=="All"){
    this.form.state=''
   }
   this.GeneralService.getActionPlanPage(this.form,this.id).then(res=>{
    console.log(res)
    this.ActionPlanData=res
    this.ActionPlanData.map((x) => {
      x.assignrname=this.allassigner.filter(res=>res.id==x.assignerid)[0].name
      x.auditername=this.auditers.filter(res=>res.id==x.auditerId)[0].name
    });
    if(this.ActionPlanData.lenght != 0){
      this.filteredData = this.ActionPlanData; // Initialize filteredData with all data initially
      this.originaldata = this.ActionPlanData;
          console.log(this.ActionPlanData)
    }
    else{
      this.GeneralService.fireEmpty();
    }

   });
  }



  applyFilter(filterValue) {
    this.filteredData = this.originaldata.filter(item => {
      const searchTextLower = filterValue.toLowerCase();
  
      return (
        (item.question_name_en && item.question_name_en.toLowerCase().includes(searchTextLower)) ||
        (item.date && item.date.toLowerCase().includes(searchTextLower)) ||
        (item.assigneranswerdate && item.assigneranswerdate.toLowerCase().includes(searchTextLower)) ||
        (item.duedate && item.duedate.toLowerCase().includes(searchTextLower)) ||
        (item.score && item.score.toString().toLowerCase().includes(searchTextLower)) || // Assuming score is a number
        (item.comment && item.comment.toLowerCase().includes(searchTextLower)) ||
        (item.assigneranswercomment && item.assigneranswercomment.toLowerCase().includes(searchTextLower))||
        (item.assignrname && item.assignrname.toLowerCase().includes(searchTextLower))||
        (item.auditername && item.auditername.toLowerCase().includes(searchTextLower))
        // Add additional filtering criteria here based on your requirements
      );
    });
    console.log(this.filteredData.length);
    if(this.filteredData.length != 0){
      this.ActionPlanData =  this.filteredData;
    }
    else{
      console.log("enter lenght zero 0")
      this.ActionPlanData =  this.originaldata;

    }

  }
  


  onSearchChange(filterValue:String) {
    console.log("onSearchChange")
    this.applyFilter(filterValue);
  }
  
  getUserById(id){
this.GeneralService.GetUserWithID(id).then(res=>{
  console.log(res);
  return res.name;
})
  }
  


  clear(){
   this.form.startdate=''
   this.form.enddate=''
   this.form.moduleid=''
   this.form.departmentid=''
   this.form.assignerid=''
   this.form.branchid=''
   this.form.state=''
    this.questions=[];
    this.clientaudit=[];
    this.clientauditcat=[];
    this.audit=[];

  }
}
